import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_1010_2990)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M19.1109 3.20461L16.9829 1.07664C16.6137 0.707426 16.1129 0.500003 15.5908 0.5L8.53125 0.5C7.44393 0.5 6.5625 1.38143 6.5625 2.46875V4.4375H3.28125C2.19393 4.4375 1.3125 5.31893 1.3125 6.40625V19.5312C1.3125 20.6186 2.19393 21.5 3.28125 21.5H12.4688C13.5561 21.5 14.4375 20.6186 14.4375 19.5312V17.5625H17.7188C18.8061 17.5625 19.6875 16.6811 19.6875 15.5938V4.59672C19.6875 4.07458 19.4801 3.57382 19.1109 3.20461ZM15.75 1.83264C15.8654 1.86111 15.9708 1.92061 16.0548 2.0047L18.1828 4.13271C18.2668 4.21671 18.3263 4.32211 18.3548 4.4375H15.75V1.83264ZM13.125 19.5312C13.125 19.8931 12.8306 20.1875 12.4688 20.1875H3.28125C2.91941 20.1875 2.625 19.8931 2.625 19.5312V6.40625C2.625 6.04441 2.91941 5.75 3.28125 5.75H6.5625V15.5938C6.5625 16.6811 7.44393 17.5625 8.53125 17.5625H13.125V19.5312ZM18.375 15.5938C18.375 15.9556 18.0806 16.25 17.7188 16.25H8.53125C8.16941 16.25 7.875 15.9556 7.875 15.5938V2.46875C7.875 2.10691 8.16941 1.8125 8.53125 1.8125H14.4375V4.76562C14.4375 5.30703 14.8805 5.75 15.4219 5.75H18.375V15.5938Z",
				fill: "#313131"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1010_2990",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 21,
				height: 21,
				fill: "white",
				transform: "translate(0 0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
